/**
 * Simple search JS controller.
 *
 * This class handles the filtering of items on simple search result views.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class SimpleSearch. This gets mapped with the keyword SimpleSearch and its
 * docready method is fired automatically on pages where there's a
 * class called 'SimpleSearch' on the html tag.
 */
class SimpleSearch {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        // The text input filters.
        this.textFilters    = $( '.js-text-filter' );

        this.searchButton   = $( '#js-search-button' );

        // The first caching of all results before hiding anything.
        this.listItems      = $( '.js-result' );

        // The disclaimer that is shown if there's no items
        this.noItemsFound   = $( '#js-no-items' );

        this.searchForm     = $( '#js-search-form' );
        this.formType       = this.searchForm.attr( 'data-type' );
        this.resultsHeading = $( '#js-results-heading' );

        this.foundItems     = 0;

        // This is to show all the searchable items
        this.showAll = $( '#js-show-all' );
    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {
        // Bind a handler to the search button click.
        this.searchForm.on( 'submit', e => this.filterResults( e ) );

        // Show all hidden searchable items on a click of the show all -button
        this.showAll.on( 'click', () => {

            // Go through each hidden item and remove the hidden class
            this.listItems.each( ( index, item ) => {
                $( item ).removeClass( 'js-hidden' );
            });
        });

    }

    /**
     * This hides the items and shows the filters when javascript is loaded. Otherwise
     * users can see them all and there's no need for filters.
     */
    a11y() {

        this.listItems.each( ( index, item ) => {
            $( item ).addClass( 'js-hidden' );
        });

        this.searchForm.addClass( 'js-active' );
    }

    /**
     * With this method we make changes in the result items
     * when the filters are clicked.
     *
     * @param type string This checks the type of search form (agents, city, subsidiaries)
     * @param {event object} e
     */
    filterResults( e = false, type ) {
        
        if ( e ) {

            // Stop the event with the static method from the Common class.
            Theme.Common.stop( e );
        }

        // Type of search form is by default city
        if ( ! type ){
            type = 'city';
        }

        this.listItems.addClass( 'js-hidden' );
        this.noItemsFound.removeClass( 'js-active' );
        this.resultsHeading.removeClass( 'js-active' );

        this.foundItems     = 0;
        const activeFilters = {
            'local_unit': false,
            'city': false
        };

        // Loop through text filters and get value from each
        this.textFilters.each( ( index, filter ) => {

            const filterVal =  $( filter ).val().toLowerCase();

            if ( filterVal.length >= 2 ) {

                const filterName = $( filter ).attr( 'name' );

                if ( filterName == 'filter-city' ) {
                    activeFilters.city = filterVal;
                } else {
                    activeFilters.local_unit = filterVal;
                }
            }
        });

        // Loop through all items.
        this.listItems.each( ( index, listItem ) => {

            let itemLocalUnit       = listItem.dataset.name;
            let itemLocalUnitFound  = false;

            let itemCities          = listItem.dataset.city;
            let itemCitiesArray     = false;
            let itemCitiesFound     = false;

            let itemActive          = false;

            /**
             * Get the cities from item's data and format them
             * to an array with lowercase letters. Check if the
             * city filter value matches some of the values in the array
             * and set the found flag accordingly.
             */
            if ( typeof itemCities !== 'undefined' ) {

                itemCitiesArray = itemCities.split( ',' );

                itemCitiesArray = itemCitiesArray.map( ( city ) => {
                    return city.toLowerCase();
                });

                itemCitiesArray.map( ( city ) => {
                    if ( city.indexOf( activeFilters.city ) > -1 ) {
                        itemCitiesFound = true;
                    }
                })
            }

            /**
             * Get the local unit (name) attribute from the item and format it to lowercase.
             * Check if the name filter value matches some part of the name and
             * set the found flag accordingly.
             */
            if ( typeof itemLocalUnit !== 'undefined' ) {

                itemLocalUnit = itemLocalUnit.toLowerCase();

                if ( itemLocalUnit.indexOf( activeFilters.local_unit ) > -1 ) {

                    itemLocalUnitFound = true;
                }
            }

            /**
             * If one of the filters was filled and there was
             * a match, set the active flag to true.
             */
            if ( activeFilters.local_unit || activeFilters.city ) {

                if ( itemLocalUnitFound || itemCitiesFound ) {

                    itemActive = true;
                }
            }

            /**
             * If both of the filters were filled, we need to
             * reset the active flag and check if there was a match
             * to them both. Only then we set the active flag back to true.
             */
            if ( activeFilters.local_unit && activeFilters.city ) {

                itemActive = false;

                if ( itemLocalUnitFound && itemCitiesFound ) {

                    itemActive = true;
                }

            }

            /**
             * If the flag is set, show the item. Also count found items
             * so that we know when to display the 'not found' text.
             */
            if ( itemActive ) {
                $( listItem ).removeClass( 'js-hidden' );
                this.foundItems++;
            }
        });

        /**
         * After filtering the results, call for a method
         * that either shows the results heading or the
         * 'not found' text.
         */
        this.assertItemsFound();
    }

    /**
     * This displays the 'not found' text
     * if there were no results and shows the
     * result heading if there were.
     * If all fields were left empty on submit, show nothing
     */
    assertItemsFound() {

        if ( this.foundItems > 0 ) {

            this.resultsHeading.addClass( 'js-active' ).focus();

        } else {

            let fieldsEmpty = true;
            this.textFilters.each( ( index, filter ) => {
                if ($( filter ).val()) {
                    fieldsEmpty = false;
                }
            });

            if ( fieldsEmpty ) {
                this.noItemsFound.removeClass( 'js-active' ).focus();
            } else {
                this.noItemsFound.addClass( 'js-active' ).focus();
            }
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.a11y();
        this.events();
    }

}

// Export the class reference.
module.exports = SimpleSearch;



// WEBPACK FOOTER //
// ./assets/scripts/simplesearch.js